import {
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  List,
  ListItem,
  Link,
  Typography,
} from '@material-ui/core'
import useStyles from './styles'
import { TikTokIcon } from 'components/icons'
import {
  Instagram,
  Facebook,
  Pinterest,
  Twitter,
  YouTube,
  Apple,
  Android,
} from '@material-ui/icons'
import * as blUrls from 'lib/urls'

export interface NavGroup {
  heading: string
  href?: string
  links: Array<{
    href: string
    name: string
  }>
}

export interface FooterWidgetProps {
  navGroups: Array<NavGroup>
}

export default function FooterWidget({ navGroups }: FooterWidgetProps) {
  const classes = useStyles()
  return (
    <footer className={classes.root}>
      <Container disableGutters>
        <Box p={4}>
          <Grid container spacing={2} justifyContent="center">
            {navGroups.map((group: NavGroup) => (
              <Grid item key={group.heading} sm={2} xs={6}>
                <Link className={classes.navHeading} href={group.href}>
                  {group.heading}
                </Link>
                <Hidden xsDown>
                  <List>
                    {group.links.map((item: any) => (
                      <ListItem disableGutters key={item.name}>
                        <Link
                          className={classes.navLink}
                          href={item.href}
                          target={item.target ?? '_self'}
                        >
                          {item.name}
                        </Link>
                      </ListItem>
                    ))}
                  </List>
                </Hidden>
              </Grid>
            ))}
            <Grid item sm={4} xs={12}>
              <Typography className={classes.navHeading} variant="body2">
                Connect With Us
              </Typography>
              <div className={classes.socialIconsWrapper}>
                <Link href={blUrls.tiktokUrl} className={classes.socialIcon}>
                  <TikTokIcon
                    className=""
                    svgClassName=""
                    width="18"
                    height="18"
                  />
                </Link>
                <Link href={blUrls.instagramUrl} className={classes.socialIcon}>
                  <Instagram />
                </Link>
                <Link href={blUrls.facebookUrl} className={classes.socialIcon}>
                  <Facebook />
                </Link>
                <Link href={blUrls.pinterestUrl} className={classes.socialIcon}>
                  <Pinterest />
                </Link>
                <Link href={blUrls.twitterUrl} className={classes.socialIcon}>
                  <Twitter />
                </Link>
                <Link href={blUrls.youtubeUrl} className={classes.socialIcon}>
                  <YouTube />
                </Link>
              </div>

              <Typography className={classes.navHeading} variant="body2">
                Download our app
              </Typography>
              <div className={classes.downloadButtonsWrapper}>
                <Button
                  href={blUrls.iOSAppUrl}
                  className={classes.downloadButton}
                >
                  <Apple />
                  &nbsp;Apple Store
                </Button>
                <Button
                  href={blUrls.androidAppUrl}
                  className={classes.downloadButton}
                >
                  <Android />
                  &nbsp;Google Play
                </Button>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.copyright}>
              <Typography variant="caption">
                &copy; 2011-{new Date().getFullYear()} Babylist, Inc
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </footer>
  )
}
